import(/* webpackMode: "eager" */ "/home/ubuntu/download/69a672264fab3d0014dccd81/kratapillar/src/app/not-found.tsx");
